import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import bgBanner from '../images/banner/banner.png'

const styles = () => ({
    banner: {
        height: 133,
        display:'flex',
        position: 'relative',
        '& img':{
            width: '61%',
            position: 'absolute',
            right: 0,
            height: 133,
            zIndex: 0
        },
        '& .left': {
            background: 'linear-gradient(270deg, rgba(14, 56, 96, 0) 8.24%, #0E2F60 34.94%, #0A0730 97.58%)',
            width: '61%',
            zIndex: 1
        }
    }
});

class Banner extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const {
            classes,
        } = this.props;
        return (
            <div className={classes.banner}>
                <div className={'left'} />
                <img src={bgBanner} alt={'banner'}/>
            </div>
        )
    }
}

Banner.defaultProps = {

}

Banner.propTypes = {
    classes: PropTypes.object.isRequired
}

export default compose(
    withStyles(styles),
    withTranslation()
)(Banner);